import BaseModel from './BaseModel';
import * as AT from '../../components/container/attributes';
import {HitUtils} from '@hit/components/src/utils/hit/HitUtils';

export default class Contact extends BaseModel {
  constructor({
    id,
    firstName = undefined,
    lastName = undefined,
    role = undefined,
    nssoNo = undefined,
    nssoLimosaNo = undefined,
  }) {
    super(id, '', '');
    this.firstName = firstName;
    this.lastName = lastName;
    this.role = role;
    this.nssoNo = nssoNo;
    this.nssoLimosaNo = nssoLimosaNo;
  }

  get fullDesignation() {
    return HitUtils.createStandardDesignation({
      number: this.number,
      designation:
        this.firstName || this.lastName
          ? `${this.firstName || ''} ${this.lastName || ''}`
          : this.designation,
    });
  }

  static get joinAttrsKey() {
    return ['firstName', 'lastName', 'role', 'nssoNo', 'nssoLimosaNo'];
  }
  static get fkName() {
    return 'contact_id';
  }
  static get apiRoute() {
    return 'contact';
  }
  static get detailPageRoute() {
    return 'contactsView';
  }
  static get listPageRoute() {
    return 'contactsView';
  }
  static get orderKey() {
    return 'first_name';
  }
  static get orderOrder() {
    return 'asc';
  }
  get fkName() {
    return Contact.fkName;
  }
  get apiRoute() {
    return Contact.apiRoute;
  }
  get listPageRoute() {
    return Contact.listPageRoute;
  }
  get detailPageRoute() {
    return Contact.detailPageRoute;
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(
      ['name', 'role'],
      ['firstName', 'lastName', 'nssoNo', 'nssoLimosaNo'],
    );
  }

  static get entityListDisplayAttrs() {
    return this.getAttributes(
      ['firstName', 'lastName', 'role'],
      ['nssoNo', 'nssoLimosaNo'],
    );
  }

  static get listDisplayAttrs() {
    return this.getAttributes(
      ['name', 'role', 'nssoNo', 'nssoLimosaNo'],
      ['id', 'firstName', 'lastName'],
    );
  }

  static get allAttributes() {
    return [
      new AT.StringAttribute({
        name: 'id',
        tableProperties: {
          header: 'hit-app.common.id',
          maxWidth: '1fr',
        },
      }),
      new AT.StringAttribute({
        name: 'firstName',
        column: 'first_name',
        tableProperties: {
          header: 'hit-app.common.first-name',
          maxWidth: '1fr',
        },
      }),
      new AT.StringAttribute({
        name: 'lastName',
        column: 'last_name',
        tableProperties: {
          header: 'hit-app.common.last-name',
          maxWidth: '1fr',
        },
      }),
      new AT.NotFetchedAttribute({
        name: 'name',
        tableProperties: {
          header: 'hit-app.common.first-name',
        },
        transform: (data) => `${data.firstName} ${data.lastName}`,
      }),
      new AT.StringAttribute({
        name: 'role',
        column: 'comment',
        tableProperties: {
          header: 'hit-app.common.role',
          maxWidth: '1fr',
        },
      }),
      new AT.StringAttribute({
        name: 'nssoNo',
        column: 'nsso_no',
        tableProperties: {
          header: 'hit-app.common.nsso-no',
        },
      }),
      new AT.StringAttribute({
        name: 'nssoLimosaNo',
        column: 'nsso_limosa_no',
        tableProperties: {
          header: 'hit-app.common.nsso-limosa-no',
        },
      }),
    ];
  }
}
